import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { WithTheme } from '@pb/styles';

import { TCustomProperties } from './responsive-render.types';

const getResponsiveStyles = ({
    showOnBreakpoints,
    theme,
}: WithTheme<TCustomProperties>): FlattenSimpleInterpolation => {
    if (showOnBreakpoints.length === 0) {
        return css`
            display: none;
        `;
    }

    const mediaQuery = showOnBreakpoints
        .map(breakpointName => {
            const breakpoint = theme.breakpoints[breakpointName];

            const { min, max } = breakpoint;
            return `(min-width: ${min}) and (max-width: ${max})`;
        })
        .join(', ');

    return css`
        display: none;

        @media ${mediaQuery} {
            display: initial;
        }
    `;
};

export const StyledDiv = styled.div<TCustomProperties>`
    ${getResponsiveStyles}
`;
